module.exports = __webpack_public_path__ + "assets/images/project/satellite-images/nongsa-2015.jpg?v=e63a0834";